import {
    MdAssignment,
    MdBiotech,
    MdDescription,
    MdEventNote,
    MdHandshake,
    MdHealthAndSafety,
    MdHistory,
    MdLocalHospital,
    MdMedicalServices,
    MdMonitorHeart,
    MdNote,
    MdReceipt,
    MdSend,
    MdSummarize,
    MdTimeline,
    MdTrendingUp,
    MdWarning,
} from 'react-icons/md'

export interface ProntuarioTab {
    id: string
    label: string
    /** Sufixo da rota, relativo a `/person/clients/:clientId/prontuario`. */
    path: string
    icon: React.ComponentType<{ className?: string }>
}

/**
 * Abas do prontuário, em ordem de exibição.
 *
 * Fica fora do layout porque a mesma lista alimenta duas superfícies: as abas da
 * rota do prontuário e o menu "Prontuário" das telas de atendimento — que abre a
 * aba escolhida em modal. Duas listas divergiriam na primeira aba nova.
 */
export const PRONTUARIO_TABS: ProntuarioTab[] = [
    { id: 'resumo', label: 'Resumo', path: '', icon: MdSummarize },
    { id: 'alergias', label: 'Alergias', path: '/alergias', icon: MdWarning },
    {
        id: 'antecedentes',
        label: 'Antecedentes',
        path: '/antecedentes',
        icon: MdHistory,
    },
    {
        id: 'anamneses',
        label: 'Anamneses',
        path: '/anamneses',
        icon: MdAssignment,
    },
    {
        id: 'evolucoes',
        label: 'Evoluções',
        path: '/evolucoes',
        icon: MdTrendingUp,
    },
    {
        id: 'consultas',
        label: 'Consultas',
        path: '/consultas',
        icon: MdEventNote,
    },
    { id: 'exames', label: 'Exames', path: '/exames', icon: MdBiotech },
    {
        id: 'procedimentos',
        label: 'Procedimentos',
        path: '/procedimentos',
        icon: MdMedicalServices,
    },
    {
        id: 'diagnosticos',
        label: 'Diagnósticos',
        path: '/diagnosticos',
        icon: MdLocalHospital,
    },
    {
        id: 'encaminhamentos',
        label: 'Encaminhamentos',
        path: '/encaminhamentos',
        icon: MdSend,
    },
    {
        id: 'receituario',
        label: 'Receituário',
        path: '/receituario',
        icon: MdReceipt,
    },
    {
        id: 'atestados',
        label: 'Atestados',
        path: '/atestados',
        icon: MdDescription,
    },
    {
        id: 'convenios',
        label: 'Convênios',
        path: '/convenios',
        icon: MdHealthAndSafety,
    },
    {
        id: 'consentimentos',
        label: 'Consentimentos',
        path: '/consentimentos',
        icon: MdHandshake,
    },
    {
        id: 'health-map',
        label: 'Mapa da Saúde',
        path: '/health-map',
        icon: MdMonitorHeart,
    },
    {
        id: 'anotacoes',
        label: 'Anotações',
        path: '/anotacoes',
        icon: MdNote,
    },
    { id: 'timeline', label: 'Timeline', path: '/timeline', icon: MdTimeline },
]
